import { Injectable } from '@angular/core';
import { RedirectService } from '../redirect.service';
import { PLATFORMS_URL } from './constants';

@Injectable()
export class Volusion2Service {

  constructor (private redirectService: RedirectService) {}

  navigate(): void {
    this.redirectService.redirectTo(PLATFORMS_URL.VOLUSION2);
  }
}
